import { Button } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ContractorInfoModal from '../../components/modals/ContractorInfoModal/ContractorInfoModal';
import CounterpartiesAttachments from '../CounterpartiesAttachments/CounterpartiesAttachments';
import styles from './CounterpartiesExpandedRow.module.scss';

const CounterpartiesExpandedRow = ({ counterparty }) => {
  const actualAddress = counterparty.actualAddress?.fullAddress;
  const registrationAddress = counterparty.registrationAddress?.fullAddress;

  const [showMoreInfoModal, setShowMoreInfoModal] = useState(false);
  const clickShowMoreInfo = () => {
    setShowMoreInfoModal(true);
  };

  const clickCancelShowMoreInfo = () => {
    setShowMoreInfoModal(false);
  };

  return (
    <div className={styles.CounterpartiesExpandedRow}>
      <div className={styles.firstCol}>
        <div className={styles.intelItem}>
          <div className={styles.name}>Собственник</div>
          {counterparty.landLordOffices?.map((landLordOffice) => {
            return (
              <Link
                key={landLordOffice.id}
                to={`/Offices/facilities/${landLordOffice.rentalHouse?.id}/rooms/${landLordOffice.id}/about`}
              >
                <div className={styles.blockHighlight}>
                  {landLordOffice.name}
                </div>
              </Link>
            );
          })}
          {!counterparty.landLordOffices?.length && '-'}
        </div>
      </div>
      <div className={styles.secondCol}>
        <div className={styles.intelItem}>
          <div className={styles.name}>Арендатор</div>
          <div className={styles.flex}>
            {counterparty.tenatsOffices?.map((tenantsOffice) => {
              return (
                <Link
                  key={tenantsOffice.id}
                  to={`/Offices/facilities/${tenantsOffice.rentalHouse?.id}/rooms/${tenantsOffice.id}/about`}
                >
                  <div className={styles.blockHighlight}>
                    {tenantsOffice.name}
                  </div>
                </Link>
              );
            })}
            {!counterparty.tenatsOffices?.length && '-'}
          </div>
        </div>
      </div>
      <div className={styles.commonCol}>
        <div className={styles.intelItem}>
          <div className={styles.name}>Почта</div>
          {counterparty.email ? (
            <a
              href={`mailto:${counterparty.email}`}
              className={styles.highlight}
            >
              {counterparty.email}
            </a>
          ) : (
            '-'
          )}
        </div>
        <div className={styles.intelItem}>
          <div className={styles.name}>Телефон</div>
          {counterparty.phoneNumber ? (
            <a
              href={`tel:${counterparty.phoneNumber}`}
              className={styles.highlight}
            >
              {counterparty.phoneNumber}
            </a>
          ) : (
            '-'
          )}
        </div>
      </div>
      <div className={styles.commonCol}>
        <div className={styles.intelItem}>
          <div className={styles.name}>
            {counterparty.type?.name === 'физическое лицо'
              ? 'Адрес регистрации'
              : 'Юридический адрес'}
          </div>
          <div>{registrationAddress || '-'}</div>
        </div>
        <div className={styles.intelItem}>
          {counterparty.type?.name === 'юридическое лицо' && (
            <>
              <div className={styles.name}>Фактический адрес</div>
              <div>
                {!actualAddress
                  ? '-'
                  : actualAddress === registrationAddress
                  ? 'Совпадает с юридическим адресом'
                  : actualAddress}
              </div>
            </>
          )}
        </div>
        <Button
          type={'primary'}
          className={styles.moreInfoButton}
          onClick={clickShowMoreInfo}
        >
          Полная информация
        </Button>
      </div>
      <div className={styles.lastCol}>
        <CounterpartiesAttachments counterparty={counterparty} />
      </div>
      <ContractorInfoModal
        isPerson={counterparty.type.name === 'физическое лицо'}
        counterparty={counterparty}
        visible={showMoreInfoModal}
        onCancel={clickCancelShowMoreInfo}
      />
    </div>
  );
};

export default CounterpartiesExpandedRow;
